
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

function bind(el, binding, vNode) {
  if (typeof binding.value !== 'function') {
    return;
  }

  function handler(evt) {
    if (!vNode.context) {
      return;
    }

    const elements = evt.path || evt.composedPath && evt.composedPath();

    if (elements && elements.length > 0) {
      elements.unshift(evt.target);
    }

    if (el.contains(evt.target)) {
      return;
    }

    el.__PendoOnClickAway__.callback(evt);
  }

  el.__PendoOnClickAway__ = {
    handler,
    callback: binding.value
  };
  document.body.addEventListener('click', handler);
}

function update(el, binding) {
  if (typeof binding.value === 'function') {
    el.__PendoOnClickAway__.callback = binding.value;
  }
}

function unbind(el) {
  document.body.removeEventListener('click', el.__PendoOnClickAway__.handler);
  delete el.__PendoOnClickAway__;
}

const PendoOnClickAway = {
  bind,
  update,
  unbind
};

export default PendoOnClickAway;
export { PendoOnClickAway };
